import cytoscape from 'cytoscape';
import { Accessor, createEffect } from 'solid-js';

type RelationshipsGraphTabProps = {
    nodeClicked?: (node: Node) => void;
    data: Accessor<any>;
};
type Node = { name: string; id: number };
export default function Graph (props: RelationshipsGraphTabProps) {
    let container: HTMLDivElement | undefined;
    let cy: cytoscape.Core | undefined;
    const distinct = (arr: any[], func: (item: any) => any): any[] => {
        const result = [];
        const map = new Map();
        for (const item of arr) {
            if (!map.has(func(item))) {
                map.set(func(item), true);
                result.push(item);
            }
        }
        return result;
    };
    const toElements = (data: any) => {
        const sourceNodes : any[] = data.map((x: any) => {
            return {
                data: {
                    id: x.Source.Id,
                    name: x.Source.Name
                }
            };
        });
        const targetNodes : any[] = data.map((x: any) => {
            return {
                data: {
                    id: x.Target.Id,
                    name: x.Target.Name
                }
            }
        });
        const edges : any[] = data.map((x: any) => {
            return {
                data: {
                    id: x.Source.Id + "_" + x.Edge.Id + "_" + x.Target.Id,
                    name: x.Edge.Name,
                    source: x.Source.Id,
                    target: x.Target.Id
                }
            };
        });
        const combined = sourceNodes.concat(targetNodes).concat(edges);
        const elements = distinct(combined, x => x.data.id);
        return elements;
    };
    const loadGraph = async () => {
        const data = props.data();
        const elements = toElements(data.Artists);
        cy = cytoscape({
            container: container,
            elements: elements,
            layout: {
                name: "cose",
                randomize: true
            },
            style: [
                {
                    selector: 'node',
                    style: {
                        'background-color': '#666',
                        'label': 'data(name)',
                        'font-size': '0.5em'
                    }
                },
                {
                    selector: 'edge',
                    style: {
                        'width': 3,
                        'label': 'data(name)',
                        'curve-style': 'bezier',
                        'line-color': 'red',
                        'target-arrow-color': 'red',
                        'target-arrow-shape': 'triangle',
                        'font-size': '0.4em',
                        'color': 'blue'
                    }
                }
            ]
        });
        cy.on('click', 'node', function (evt) {
            if (!props.nodeClicked){
                return;
            }
            const node = evt.target;
            console.log({ node });
            const id = parseInt(node._private.data.id);
            props.nodeClicked({ name: node._private.data.name, id: id });
        });
    };
    const setupElement = async (el: HTMLDivElement) =>{
        createEffect(async () => {
            container = el;
            await loadGraph();
        });
    };
    return (
        <div ref={setupElement} style={{ width: "100%", height: "800px" }}></div>
    );
}